export default function () {
  jQuery(document).ready((e) => {
    // update external and download links to use an SVG
    const links = $('.content-text').find('a');
    const location = window.location.hostname;

    links.each(function () {
      const hostname = $(this).prop('href', $(this)[0]).prop('hostname');

      const fileExt = $(this).attr('href').split('.').pop();
      const checkExtensions = ['pdf', 'doc', 'docx', 'mp4', 'mp3', 'exe'];

      if ($(this).attr('download')) {
        $(this)
          .addClass('download')
          .append($('#downloadLinkText').html())
          .append($('#downloadLinkIcon').html());
      } else if (checkExtensions.includes(fileExt)) {
        $(this)
          .addClass('download')
          .append($('#downloadLinkText').html())
          .append($('#downloadLinkIcon').html());
      } else if ($(this).attr('target') === '_blank') {
        $(this)
          .addClass('external-link')
          .addClass('text-link')
          .append($('#externalLinkText').html())
          .append($('#externalLinkIcon').html());
      } else if ($(this).attr('href') && hostname !== location) {
        $(this)
          .addClass('external-link')
          .addClass('text-link')
          .append($('#externalLinkText').html())
          .append($('#externalLinkIcon').html());
      } else if ($(this).attr('href').includes('#') && hostname === location) {
        $(this)
          .addClass('anchor-link')
          .append($('#anchorLinkText').html())
          .append($('#anchorLinkIcon').html());
      }
    });

    // update content images to use <figure>
    const images = $('.content').find('img:not(.accImage)');

    images.each(function () {
      const caption = $(this).next();
      $(this).parent().removeAttr('style');

      const height = $(this).attr('height');
      const width = $(this).attr('width');
      $(this).removeAttr('height width');
      $(this)
        .attr('max-height', height)
        .attr('max-width', width);

      $(this).wrap('<figure></figure>');

      if (caption) {
        const text = caption.text();
        $(this).after(`<figcaption>${text}</figcaption>`);
        caption.remove();
      }
    });
  });
}



// WEBPACK FOOTER //
// ./themes/app/src/js/content-updater.js